import React from 'react';

const ArrowLeftOpen = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 14" {...props}>
    <path
      fillRule="evenodd"
      d="M6.722 12.478a1.055 1.055 0 0 0-.008-1.444L2.83 6.98l3.884-4.055a1.057 1.057 0 0 0 .008-1.443l-.034-.035a.944.944 0 0 0-1.376 0L.688 6.262a1.042 1.042 0 0 0 0 1.434l4.624 4.816a.95.95 0 0 0 1.376 0l.034-.034z"
    />
  </svg>
);

export default ArrowLeftOpen;
